module.exports = __webpack_public_path__ + "static/media/approve.765df02b.png";